import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage, withFormik } from "formik";
import { Modal as BootstrapModal } from "react-bootstrap";
import { Debug } from "../forms/Debug";
import { Container, Row, Col, Modal, Button } from "react-bootstrap";
import * as yup from "yup";
import { required } from "../forms/util/validation";
import { RadioButton } from "../forms/elements";
import AddIcon from '../../images/svg/add.svg';
import CarIcon from '../../images/svg/Car-Icon.svg';
import TruckIcon from '../../images/svg/Truck-Icon.svg';
import SuvIcon from '../../images/svg/SUV-icon.svg';
import VanIcon from '../../images/svg/Van-Icon.svg';
import HatchIcon from '../../images/svg/Hatchback-Icon.svg';
import OtherVehicleIcon from '../../images/svg/Other-Vehicle-Icon.svg';
import CarIconRebrand from '../../images/rebrand/svg/Car-Icon.svg';
import TruckIconRebrand from '../../images/rebrand/svg/Truck-Icon.svg';
import SuvIconRebrand from '../../images/rebrand/svg/SUV-icon.svg';
import VanIconRebrand from '../../images/rebrand/svg/Van-Icon.svg';
import HatchIconRebrand from '../../images/rebrand/svg/Hatchback-Icon.svg';
import OtherVehicleIconRebrand from '../../images/rebrand/svg/Other-Vehicle-Icon.svg';
import White from '../../images/svg/WhiteIcon.svg';
import Silver from '../../images/svg/GrayIcon.svg';
import Black from '../../images/svg/BlackIcon.svg';
import Red from '../../images/svg/RedIcon.svg';
import Blue from '../../images/svg/BlueIcon.svg';
import OtherColor from '../../images/svg/OtherIcon.svg'; // Type defintitions

import * as TYPES from "../../types"; // Constants

import * as CONSTANTS from "../../constants"; // JSS

import { Link, RichText } from "@sitecore-jss/sitecore-jss-react";
import { SitecoreLink } from '../link/Link'; // Design System

import Heading from "../heading/Heading";
import Wrapper from "../wrapper/Wrapper";
import axios from "axios";
import * as UTIL from "../../util";
import { VehicleMenu } from "./VehicleMenu";
import { useFlags } from "launchdarkly-react-client-sdk";
import { FaCheck } from 'react-icons/fa';

var Filter = require('bad-words');

var filter = new Filter();

function Parent(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  var handleClose = function handleClose() {
    return setShow(false);
  };

  var handleShow = function handleShow() {
    return setShow(true);
  };

  var setHasErrors = function setHasErrors() {
    return useState(false);
  };

  var handleRedirect = function handleRedirect() {
    window.location = "/";
  };

  return /*#__PURE__*/React.createElement("div", null, children(show, handleShow, handleClose, handleRedirect, setHasErrors));
} // const routeURL = `/crackerbarrel/api/order/customer-arrival-notification`;


var routeURL = "".concat(UTIL.apiUtil.API.getOloCurbside);
var formikEnhancer = withFormik({
  mapPropsToValues: function mapPropsToValues(props) {
    return {
      ParkingSpot: props === null || props === void 0 ? void 0 : props.ParkingSpot,
      Model: props === null || props === void 0 ? void 0 : props.vehicleType,
      Color: props === null || props === void 0 ? void 0 : props.vehicleColor,
      Make: props === null || props === void 0 ? void 0 : props.Make
    };
  },
  validationSchema: yup.object().shape({
    ParkingSpot: required("Please give your feedback")
  }),
  handleSubmit: function handleSubmit(values, _ref2) {
    var setSubmitting = _ref2.setSubmitting;
    setTimeout(function () {
      JSON.stringify(values, null, 2);
      setSubmitting(false);
      var cleanMake = filter.clean(values === null || values === void 0 ? void 0 : values.Make);
      values.Make = cleanMake;
    }, 1000);
    axios({
      method: "post",
      url: routeURL,
      data: values
    }).then(function (response) {
      //handle success
      console.log(response);
    }).catch(function (response) {
      //handle error
      console.log(response);
    });
  }
});

var LandingPage = function LandingPage(props) {
  var _props$values, _props$values$Parking, _props$values2, _props$values2$Make;

  var flags = useFlags();
  var useNewRebrandStyles = flags['releaseRebrandDstr6457'] || false;
  var model = props.model,
      errors = props.errors,
      type = props.type,
      align = props.align,
      layout = props.layout,
      _props$vehicleListTyp = props.vehicleListTypes,
      vehicleListTypes = _props$vehicleListTyp === void 0 ? [{
    name: "Car",
    iconPath: useNewRebrandStyles ? CarIconRebrand : CarIcon
  }, {
    name: "Truck",
    iconPath: useNewRebrandStyles ? TruckIconRebrand : TruckIcon
  }, {
    name: "SUV",
    iconPath: useNewRebrandStyles ? SuvIconRebrand : SuvIcon
  }, {
    name: "Van",
    iconPath: useNewRebrandStyles ? VanIconRebrand : VanIcon
  }, {
    name: "Hatch-back",
    iconPath: useNewRebrandStyles ? HatchIconRebrand : HatchIcon
  }, {
    name: "Other",
    iconPath: useNewRebrandStyles ? OtherVehicleIconRebrand : OtherVehicleIcon
  }] : _props$vehicleListTyp,
      _props$vehicleListCol = props.vehicleListColors,
      vehicleListColors = _props$vehicleListCol === void 0 ? [{
    name: "White",
    iconPath: White
  }, {
    name: "Silver / Gray",
    iconPath: Silver
  }, {
    name: "Black",
    iconPath: Black
  }, {
    name: "Red",
    iconPath: Red
  }, {
    name: "Blue",
    iconPath: Blue
  }, {
    name: "Other",
    iconPath: OtherColor
  }] : _props$vehicleListCol,
      _props$isEditing = props.isEditing,
      isEditing = _props$isEditing === void 0 ? false : _props$isEditing,
      htmlId = props.htmlId,
      position = props.position,
      values = props.values;
  useEffect(function () {
    var payload = {
      catalog: (model === null || model === void 0 ? void 0 : model.catalog) || "",
      orderid: (model === null || model === void 0 ? void 0 : model.orderid) || "",
      storenumber: (model === null || model === void 0 ? void 0 : model.storenumber) || "",
      storephone: (model === null || model === void 0 ? void 0 : model.storephone) || "",
      firstname: (model === null || model === void 0 ? void 0 : model.firstname) || "",
      lastname: (model === null || model === void 0 ? void 0 : model.lastname) || "",
      phonenumber: (model === null || model === void 0 ? void 0 : model.phonenumber) || "",
      make: (model === null || model === void 0 ? void 0 : model.make) || "",
      model: (model === null || model === void 0 ? void 0 : model.model) || "",
      color: (model === null || model === void 0 ? void 0 : model.color) || ""
    };
    props.setFieldValue('Catalog', payload.catalog), props.setFieldValue('OrderId', payload.orderid), props.setFieldValue('StoreNumber', payload.storenumber), props.setFieldValue('StorePhone', payload.storephone), props.setFieldValue('FirstName', payload.firstname), props.setFieldValue('LastName', payload.lastname), props.setFieldValue('PhoneNumber', payload.phonenumber), props.setFieldValue('CarMake', payload.make), props.setFieldValue('CarModel', payload.model), props.setFieldValue('CarColor', payload.color);
  }, []);

  var _onchange = function onchange(data) {
    setValue(data);
  };

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      value = _useState4[0],
      setValue = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      hasErrors = _useState6[0],
      setHasErrors = _useState6[1];

  var _useState7 = useState((model === null || model === void 0 ? void 0 : model.make) != "" && (model === null || model === void 0 ? void 0 : model.model) != "" && (model === null || model === void 0 ? void 0 : model.color) != ""),
      _useState8 = _slicedToArray(_useState7, 2),
      carInfoFromCheckout = _useState8[0],
      setCarInfoFromCheckout = _useState8[1];

  var container = typeof type !== "undefined" ? "cb-banner__container" : "";
  var spotModel = {
    value: {
      text: "Enter '0' and park nearby with your flashers on if there are no numbered spots available."
    }
  };
  var makeAlert = false;
  var parkingAlert = false;
  var parkingLength = props === null || props === void 0 ? void 0 : (_props$values = props.values) === null || _props$values === void 0 ? void 0 : (_props$values$Parking = _props$values.ParkingSpot) === null || _props$values$Parking === void 0 ? void 0 : _props$values$Parking.toString().length;
  var parkingLimit = parkingLength > 2;

  if (parkingLimit) {
    parkingAlert = true;
  }

  var makelength = props === null || props === void 0 ? void 0 : (_props$values2 = props.values) === null || _props$values2 === void 0 ? void 0 : (_props$values2$Make = _props$values2.Make) === null || _props$values2$Make === void 0 ? void 0 : _props$values2$Make.toString().length;
  var makeLimit = makelength > 15;

  if (makeLimit) {
    makeAlert = true;
  }

  var carInfoFromCheckoutDisplayString = "";

  if (carInfoFromCheckout) {
    carInfoFromCheckoutDisplayString = (model === null || model === void 0 ? void 0 : model.make) + " " + (model === null || model === void 0 ? void 0 : model.model) + " " + (model === null || model === void 0 ? void 0 : model.color);
    props.values.Color = model === null || model === void 0 ? void 0 : model.color;
    props.values.Make = model === null || model === void 0 ? void 0 : model.make;
    props.values.Model = model === null || model === void 0 ? void 0 : model.model;
  } else {
    carInfoFromCheckoutDisplayString = props.values.Color + " " + props.values.Make + " " + props.values.Model;
  }

  var ExperienceValidation = "";

  if (carInfoFromCheckout) {
    ExperienceValidation = errors.ParkingSpot || props.values.ParkingSpot === undefined || props.values.ParkingSpot === "";
  } else {
    ExperienceValidation = errors.ParkingSpot || props.values.ParkingSpot === undefined || props.values.ParkingSpot === "" || props.values.Make === "" || parkingLimit || makeLimit || errors.Color || props.values.Color === undefined || errors.Make || props.values.Make === undefined || errors.Model || props.values.Model === undefined;
  }

  var onSubmit = function onSubmit(e) {
    e.preventDefault();
    axios({
      method: "post",
      url: routeURL,
      data: values
    }).then(function (response) {
      var _response$data;

      //handle success
      if (!(response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.SentToOloExpo)) {
        setHasErrors(true);
      }

      console.log(response);
    }).catch(function (response) {
      //handle error
      setHasErrors(true);
      console.log(response);
    });
  };

  return /*#__PURE__*/React.createElement(Wrapper, {
    layout: layout,
    className: "cb-curbside-check-in"
  }, /*#__PURE__*/React.createElement("div", {
    className: container,
    id: htmlId
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-banner__copy-container",
    style: {
      paddingTop: "30px"
    }
  }, (model === null || model === void 0 ? void 0 : model.title) && /*#__PURE__*/React.createElement(LandingPageComponent, {
    field: model.title,
    level: "1",
    className: "cb-banner__title"
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundColor: "#9d2235 !important",
      borderColor: "#9d2235 !important"
    },
    className: "shadow p-3 mb-5 bg-white rounded text-center cb-curbside-check-in__form-container"
  }, /*#__PURE__*/React.createElement("div", {
    level: "2",
    className: "cb-banner__text",
    style: {
      fontWeight: "bold",
      fontSize: "larger"
    }
  }, "Which parking spot are you in?"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Field, {
    name: "ParkingSpot",
    type: "number",
    pattern: "^[1-9]\\d*$",
    className: "cb-menu-counter__input cb-form__input form-control mx-auto"
  }), /*#__PURE__*/React.createElement("div", {
    className: "cb-curbside-check-in__padding",
    style: {
      paddingBottom: "30px"
    }
  }), parkingAlert && /*#__PURE__*/React.createElement("div", {
    className: "alert alert-danger",
    role: "alert"
  }, /*#__PURE__*/React.createElement("p", null, "Please enter your parking spot number (less than 99)")), /*#__PURE__*/React.createElement(SitecoreLink, {
    className: "cb-curbside-check-in__copy",
    style: {
      color: "#902235"
    },
    field: spotModel
  }), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
    level: "2",
    className: "cb-banner__text cb-curbside-check-in__question",
    style: {
      fontWeight: "bold",
      fontSize: "larger"
    }
  }, "What vehicle are you picking up in?"), /*#__PURE__*/React.createElement("br", null), carInfoFromCheckout && /*#__PURE__*/React.createElement("div", {
    className: "col-sm-4 mx-auto cb-curbside-check-in__radio-add-vehicle",
    style: {
      textTransform: "capitalize",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement(RadioButton, {
    name: "carInfoFromCheckoutOption",
    value: "yes",
    checked: true,
    className: "cb-type-body-sm pt-12 cb-curbside-check-in__saved-car-radio",
    labelClass: "is-active"
  }, model === null || model === void 0 ? void 0 : model.color, " ", model === null || model === void 0 ? void 0 : model.make, " ", model === null || model === void 0 ? void 0 : model.model), /*#__PURE__*/React.createElement("span", {
    className: "cb-curbside-check-in__or-text"
  }, " - OR - "), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
    onClick: function onClick(element) {
      setCarInfoFromCheckout(false);
    },
    className: "cb-curbside-check-in__add-vehicle",
    style: {
      color: "#40687F"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: AddIcon,
    alt: "Add Icon"
  }), " Add Vehicle"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null)), !carInfoFromCheckout && /*#__PURE__*/React.createElement("div", {
    className: "cb-curbside-check-in__vehicle-input-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-4 mx-auto cb-curbside-check-in__make-input-container"
  }, /*#__PURE__*/React.createElement(Field, {
    name: "Make",
    placeholder: "Vehicle Make",
    className: "cb-form__input form-control cb-form__input--full"
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      paddingBottom: "30px"
    }
  }), makeAlert && /*#__PURE__*/React.createElement("div", {
    className: "alert alert-danger",
    role: "alert"
  }, /*#__PURE__*/React.createElement("p", null, "Please limit your vehicle model to 15 characters"))), /*#__PURE__*/React.createElement("div", {
    level: "2",
    className: "cb-banner__text cb-curbside-check-in__vehicle-type-color-labels",
    style: {
      fontWeight: "bold",
      paddingBottom: "10px"
    }
  }, "Select your vehicle type"), /*#__PURE__*/React.createElement(VehicleMenu, {
    className: "cb-curbside-check-in__vehicle-type-menu",
    vehicleList: vehicleListTypes,
    onchange: function onchange(value) {
      _onchange(value), props.setFieldValue('Model', value);
    }
  }), /*#__PURE__*/React.createElement("div", {
    level: "2",
    className: "cb-banner__text cb-curbside-check-in__vehicle-type-color-labels",
    style: {
      fontWeight: "bold",
      paddingBottom: "10px",
      paddingTop: "40px"
    }
  }, "Select your vehicle color"), /*#__PURE__*/React.createElement(VehicleMenu, {
    className: "cb-curbside-check-in__vehicle-color-menu",
    vehicleList: vehicleListColors,
    onchange: function onchange(value) {
      _onchange(value), props.setFieldValue('Color', value);
    }
  }))), /*#__PURE__*/React.createElement(Parent, null, function (show, handleShow, handleClose, handleRedirect) {
    var _model$link1$value;

    return /*#__PURE__*/React.createElement("div", {
      style: {
        paddingTop: "20px"
      }
    }, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Button, {
      style: {
        marginBottom: "45px"
      },
      type: "submit",
      disabled: ExperienceValidation,
      onClick: function onClick(e) {
        return handleShow(true);
      },
      className: "cb-button-primary"
    }, "Finish Check In"), /*#__PURE__*/React.createElement(Modal, {
      show: show,
      className: "cb-location-none cb-curbside-check-in__modal",
      size: "lg"
    }, /*#__PURE__*/React.createElement(BootstrapModal.Body, null, /*#__PURE__*/React.createElement(LandingPageComponent, {
      field: {
        value: hasErrors ? '<strong>We\'re Sorry</strong>' : model.modaltitle.value
      },
      level: "1",
      className: "cb-banner__title"
    }), /*#__PURE__*/React.createElement(LandingPageComponent, {
      field: {
        value: hasErrors ? "Please Call the Store <a style=\"font-size: 2rem;\" href=\"tel:".concat(model.storephone, "\">").concat(model.storephone, "</a>") : model.subtitle.value
      },
      level: "2",
      className: "cb-banner__subtitle"
    }), !useNewRebrandStyles && /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
      className: "shadow p-3 mb-5 bg-white rounded cb-curbside-check-in__modal__container"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        fontWeight: "bold"
      },
      className: "cb-banner__text"
    }, useNewRebrandStyles ? /*#__PURE__*/React.createElement(FaCheck, {
      className: "cb-curbside-check-in__modal__check-icon"
    }, " ") : /*#__PURE__*/React.createElement("span", {
      style: {
        color: "#A0A66A"
      }
    }, "\u2713 "), "You're in this parking spot:"), /*#__PURE__*/React.createElement("div", {
      className: "cb-curbside-check-in__modal__info-value"
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        margin: "9px"
      }
    }), props.values.ParkingSpot), /*#__PURE__*/React.createElement("div", {
      style: {
        fontWeight: "bold",
        paddingTop: "20px"
      },
      className: "cb-banner__text"
    }, useNewRebrandStyles ? /*#__PURE__*/React.createElement(FaCheck, {
      className: "cb-curbside-check-in__modal__check-icon"
    }, " ") : /*#__PURE__*/React.createElement("span", {
      style: {
        color: "#A0A66A"
      }
    }, "\u2713 "), " In this vehicle:"), /*#__PURE__*/React.createElement("div", {
      className: "cb-curbside-check-in__modal__info-value"
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        margin: "9px"
      }
    }), " ", carInfoFromCheckoutDisplayString), /*#__PURE__*/React.createElement("div", {
      style: {
        color: '#007bff',
        paddingTop: "20px",
        textAlign: "right"
      },
      className: "cb-curbside-check-in__modal__change-link"
    }, /*#__PURE__*/React.createElement("a", {
      onClick: handleClose
    }, "Change"))), /*#__PURE__*/React.createElement("div", {
      class: "shadow p-3 mb-5 bg-white rounded cb-curbside-check-in__modal__cta-container"
    }, typeof (model === null || model === void 0 ? void 0 : model.text) !== "undefined" && /*#__PURE__*/React.createElement(LandingPageRichText, {
      text: {
        value: hasErrors ? '' : model.text.value
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "cb-banner__cta"
    }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, {
      className: "row-grid"
    }, Boolean((_model$link1$value = model.link1.value) === null || _model$link1$value === void 0 ? void 0 : _model$link1$value.href) ? /*#__PURE__*/React.createElement(CtaItem, {
      link: model.link1,
      id: "".concat(htmlId, "-1"),
      type: "primary"
    }) : "")))), /*#__PURE__*/React.createElement(Container, {
      style: {
        marginTop: "200px",
        paddingBottom: "20px"
      },
      className: "cb-curbside-check-in__modal__contact-container"
    }, /*#__PURE__*/React.createElement(LandingPageTelephone, {
      link: (model === null || model === void 0 ? void 0 : model.link2) || {
        href: "tel:1234567890",
        text: "1234567890"
      }
    })))));
  })))));
};

var LandingPageComponent = function LandingPageComponent(_ref3) {
  var field = _ref3.field,
      level = _ref3.level,
      className = _ref3.className;
  return /*#__PURE__*/React.createElement(Heading, {
    field: field,
    level: level,
    className: className
  });
};

var LandingPageRichText = function LandingPageRichText(_ref4) {
  var text = _ref4.text;
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-banner__copy cb-l-margin-medium--bottom"
  }, /*#__PURE__*/React.createElement(RichText, {
    field: text,
    tag: "p",
    className: "cb-banner__text"
  }));
};

var LandingPageTelephone = function LandingPageTelephone(props) {
  var _props$link = props.link,
      link = _props$link === void 0 ? {} : _props$link,
      id = props.id;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Link, {
    field: link,
    style: {
      color: "#902235",
      fontWeight: "bold",
      fontSize: "larger"
    },
    showLinkTextWithChildrenPresent: "true",
    id: id
  }));
};

var CtaItem = function CtaItem(props, type) {
  var _props$link2 = props.link,
      link = _props$link2 === void 0 ? {} : _props$link2,
      id = props.id;
  var buttonClass = type === "secondary" ? CONSTANTS.BANNER_SECONDARY_BUTTON : CONSTANTS.BANNER_PRIMARY_BUTTON;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Col, {
    className: "cb-banner__cta-item"
  }, /*#__PURE__*/React.createElement(Link, {
    field: link,
    showLinkTextWithChildrenPresent: "true",
    id: id,
    className: typeof link.value.class !== "undefined" && link.value.class !== "" ? link.value.class : buttonClass
  })));
};

export default formikEnhancer(LandingPage);